import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS } from '@/nova/theme/tokens';

export const Note = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: ${COLORS.textMuted};

  svg {
    flex: 0 0 auto;
    margin-top: 2px;
  }
`;

export const NoteText = styled(Text).attrs({ tag: 'span' as const })``;

export const Loading = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(156px, 1fr));
  gap: 18px 14px;
`;

export const Failed = styled(Text).attrs({ tag: 'paragraph' as const })`
  margin: 24px 0;
  text-align: center;
  font-size: 14px;
  color: ${COLORS.textMuted};
`;
